import React, { useState } from 'react';
import './Gallery.css';

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      src: '/images/gallery/IMG_0273.JPG',
      title: 'Medical Facility',
      category: 'Facilities'
    },
    {
      src: '/images/gallery/IMG_3425.jpg',
      title: 'Patient Care',
      category: 'Missions'
    },
    {
      src: '/images/gallery/IMG_1150.JPG',
      title: 'Medical Team',
      category: 'Team'
    },
    {
      src: '/images/gallery/IMG_1152.JPG',
      title: 'Community Care',
      category: 'Missions'
    },
    {
      src: '/images/gallery/IMG_1158.JPG',
      title: 'Surgical Suite',
      category: 'Facilities'
    },
    {
      src: '/images/gallery/IMG_3427.jpg',
      title: 'Recovery Ward',
      category: 'Facilities'
    }
  ];

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <section id="gallery" className="gallery section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">Gallery</span>
          <h2 className="section-title">Our Missions in Action</h2>
          <p className="section-description">
            See the impact of our work through these moments captured during our 
            medical missions in Cambodia and around the world.
          </p>
        </div>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              className="gallery-item"
              onClick={() => openLightbox(image)}
            >
              <img src={image.src} alt={image.title} loading="lazy" />
              <div className="gallery-overlay">
                <span className="gallery-category">{image.category}</span>
                <h3 className="gallery-title">{image.title}</h3>
                <div className="gallery-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="11" cy="11" r="8"/>
                    <path d="m21 21-4.35-4.35"/>
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="gallery-cta">
          <p>Want to see more of our work?</p>
          <a href="/about" className="btn btn-primary">View All Photos</a>
        </div>
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.src} alt={selectedImage.title} />
            <div className="lightbox-info">
              <span className="lightbox-category">{selectedImage.category}</span>
              <h3 className="lightbox-title">{selectedImage.title}</h3>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Gallery;

